import React from "react";

export const SpaServiceCard = ({ service, index }) => {
  return (
    <div
      data-testid={`spa-service-${service.slug}`}
      className="group  bg-cream reveal grid grid-cols-1 overflow-hidden lg:h-full lg:grid-cols-[minmax(17rem,0.9fr)_1.1fr]"
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="aspect-[4/3] overflow-hidden lg:aspect-auto lg:min-h-0">
        <img
          src={service.image}
          alt={service.name}
          className="w-full h-full object-contain transition-transform duration-[1500ms] ease-out group-hover:scale-110"
        />
      </div>
      <div className="flex flex-col justify-center p-7 md:p-9 lg:p-10">
        <h3 className="font-serif text-2xl md:text-3xl font-light leading-tight">{service.name}</h3>
        <p className="font-serif italic text-gold-dark mt-2 text-lg ">{service.tagline}</p>
        <p className="text-ink/60 text-lg mt-4 leading-relaxed">{service.summary}</p>
        <ul className="mt-5 flex flex-col gap-1.5">
          {service.benefits.map((benefit) => (
            <li
              key={benefit}
              className="flex items-center gap-2 text-md tracking-wide text-ink/70"
            >
              <span className="w-1 h-1 rounded-full bg-gold flex-shrink-0" />
              {benefit}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
